export default "__VITE_ASSET__BvhG8bpw__"